import React from "react";
import { Link, Switch, Route, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic";
import '../../style/auth.scss'
import Login from "./Login";
import AuthBox from "./AuthBox";

export default function AuthPage() {
	return (
		<div id="custom-auth" style={{ backgroundImage: `url(${toAbsoluteUrl('/images/Bgblur.png')})` }} >
			<div className="logo-info blur flex-column">
				<img className="logo" alt="Logo" src={toAbsoluteUrl("/images/logo.svg")} />
				<p className="slogan">Inteligência para promover bem-estar.</p>
			</div>

			<div className="box-auth">
				<div className="wrapper-auth">
					<Switch>
						<Route path="/auth/login" component={AuthBox} />
						<Redirect from="/auth" exact={true} to="/auth/login" />
						<Redirect to="/auth/login" />
					</Switch>
				</div>
			</div>
		</div>
	);
}
